
const aaa = [
	{
		path: "platform",
		component: () => import("@/views/yiliaoxin/yiliao/yiliao.vue"),
		meta:{title:'医疗工作台'},
	},
	{
		path: "tagList",
		component: () => import("@/views/yiliaoxin/tag/tagList.vue"),
		meta:{title:'医疗标签',keepAlive:true},
	},
	{
		path: "tagAdd",
		component: () => import("@/views/yiliaoxin/tag/tagAdd.vue"),
		meta:{title:'医疗标签'},
	},
]
export default aaa;